import MobileLeftArrow from '../vector/common/MobileLeftArrow';

export default function MobileBackButton() {
  return (
    <button onClick={() => history.back()} className="hidden max-md:block py-4">
      <MobileLeftArrow />
    </button>
  );
}
